import React, { useEffect, useRef, useState } from "react";
import useResize from "../../hooks/useResize";
import useWebSocket, { Status } from "../../hooks/useWebSocket";
import ChatMessage from "./ChatMessage";

const Chat = ({ inputFocused }) => {
  const [messages, setMessages] = useState([]);

  const { status } = useWebSocket({
    messageType: "chat_message",
    onMessage(data) {
      if (Array.isArray(data)) {
        setMessages((current) => data.concat(current));
      } else {
        setMessages((current) => [data].concat(current));
      }
    },
  });

  useEffect(() => {
    if (status === Status.OPEN) {
      // Clear messages on reconnect
      setMessages([]);
    }
  }, [status]);

  const chatRef = useRef();
  useEffect(() => {
    // Scroll to bottom on new message
    chatRef.current.scrollTop = chatRef.current.scrollHeight;
  }, [inputFocused]);

  const ref = useRef();
  const {
    size: height,
    resizing,
    handleResize,
    handleReset,
  } = useResize({
    axis: "y",
    minSize: 150,
    maxSize: document.body.clientHeight / 2,
    storageKey: "chatHeight",
    ref,
  });

  return (
    <section
      className={`relative border-t border-gray-200 bg-gray-100 max-h-[38dvh] lg:max-h-[45dvh] ${
        inputFocused ? "short:hidden" : ""
      }`}
      style={{ height: height || "30dvh" }}
      ref={ref}
    >
      <div
        className={`absolute flex group justify-center inset-x-0 top-0 border-t-2 lg:border-t-4 cursor-[ns-resize] transition delay-200 ${
          resizing
            ? "border-primary-600"
            : "border-transparent hover:border-primary-600"
        }`}
        onMouseDown={handleResize}
        onTouchStart={handleResize}
        onDoubleClick={handleReset}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className={`xl:hidden mt-[-1.25rem] h-6 w-6 transition delay-200 ${
            resizing
              ? "text-primary-500"
              : "text-gray-300 group-hover:text-primary-500"
          }`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={resizing ? 2 : 1}
            d="M4 6h16M4 12h16"
          />
        </svg>
      </div>
      <div
        ref={chatRef}
        className="h-full overflow-y-auto flex flex-col-reverse text-gray-800 scrollbar-minimal"
      >
        {messages.map((message, index) => (
          <ChatMessage key={index} {...message} />
        ))}
      </div>
    </section>
  );
};

export default Chat;
